/* @flow */

import React from 'react';
import glamorous from 'glamorous';
import { margin, padding, position } from 'polished';
import t from 'app/utils/translate';
import SimpleMarkdownText from 'app/components/static/SimpleMarkdownText';

type Props = {
  tagline?: string,
  desktopImage: string,
  mobileImage: string
};

const defaultProps = {
  tagline: undefined
};

const aspectRatioMobile = 750 / 577;
const aspectRatioDesktop = 2880 / 672;

const Container = glamorous.div(({ theme, mobileImage, desktopImage }) => ({
  backgroundImage: `url(${mobileImage})`,
  backgroundPosition: '0 0',
  backgroundRepeat: 'no-repeat',
  backgroundSize: '100% auto',
  paddingTop: `${100 / aspectRatioMobile}%`,
  position: 'relative',
  zIndex: -1,

  [theme.mediaQuery.desktopAndUp]: {
    backgroundImage: `url(${desktopImage})`,
    paddingTop: `${100 / aspectRatioDesktop}%`
  }
}));

const Inner = glamorous.div({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  ...position('absolute', null, '0', '20px')
});

const Subtitle = glamorous.div(props => ({
  color: 'white',
  fontSize: props.theme.fontSize.small,
  fontWeight: props.theme.fontWeight.normal,
  letterSpacing: '0.4em',
  ...margin(props.theme.spacing.tiny, null),
  textTransform: 'uppercase'
}));

const Tagline = glamorous(({ children, className }) => (
  <SimpleMarkdownText className={className} source={children} />
))(props => ({
  borderTopColor: props.theme.color.primary,
  borderTopStyle: 'solid',
  borderTopWidth: 2,
  display: 'flex',
  flexGrow: 0,
  textAlign: 'center',
  fontWeight: props.theme.fontWeight.normal,
  letterSpacing: '0.4em',
  marginTop: props.theme.spacing.small,
  marginBottom: 0,
  ...padding(props.theme.spacing.medium, props.theme.spacing.xxlarge, '0'),
  textTransform: 'uppercase'
}));

const Title = glamorous.h1(props => ({
  color: 'white',
  fontSize: props.theme.fontSize.xxlarge,
  fontWeight: props.theme.fontWeight.demiBold,
  letterSpacing: '0.25em',
  ...margin(props.theme.spacing.tiny, null),
  textTransform: 'uppercase'
}));

function HowToPlayHead({ desktopImage, mobileImage, tagline }: Props) {
  return (
    <Container desktopImage={desktopImage} mobileImage={mobileImage}>
      <Inner>
        <Title>{t('How to Play')}</Title>
        <Subtitle>{t('Daily Fantasy Sports')}</Subtitle>
        {tagline && <Tagline>{tagline}</Tagline>}
      </Inner>
    </Container>
  );
}

HowToPlayHead.defaultProps = defaultProps;

export default HowToPlayHead;
